import { useEffect } from "react";

export const SITE_URL = "https://customizestudio.com";

function setMeta(attr, key, content) {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !el;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content);
  return { el, created, prev };
}

// Client-side SEO head manager for this CRA SPA. Sets title, description,
// canonical, Open Graph tags and injects JSON-LD structured data.
export function SEO({ title, description, canonical, image, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const restores = [];
    const track = (r) => r && restores.push(r);

    track(setMeta("name", "description", description));
    track(setMeta("property", "og:title", title));
    track(setMeta("property", "og:description", description));
    track(setMeta("property", "og:url", canonical));
    track(setMeta("property", "og:type", "website"));
    track(setMeta("property", "og:image", image || `${SITE_URL}/og-image.png`));
    track(setMeta("name", "twitter:title", title));
    track(setMeta("name", "twitter:description", description));
    track(setMeta("name", "twitter:card", "summary_large_image"));

    let canonEl = null;
    let canonPrev = null;
    if (canonical) {
      canonEl = document.head.querySelector('link[rel="canonical"]');
      if (!canonEl) {
        canonEl = document.createElement("link");
        canonEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonEl);
      }
      canonPrev = canonEl.getAttribute("href");
      canonEl.setAttribute("href", canonical);
    }

    const scripts = [];
    const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    blocks.forEach((block) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.textContent = JSON.stringify(block);
      document.head.appendChild(s);
      scripts.push(s);
    });

    return () => {
      document.title = prevTitle;
      restores.forEach(({ el, created, prev }) => {
        if (created) el.remove();
        else if (prev != null) el.setAttribute("content", prev);
      });
      if (canonEl && canonPrev != null) canonEl.setAttribute("href", canonPrev);
      scripts.forEach((s) => s.remove());
    };
  }, [title, description, canonical, image, jsonLd]);

  return null;
}
